import { render } from "./Journey.vue?vue&type=template&id=2160a90e&scoped=true&ts=true"
import script from "./Journey.vue?vue&type=script&lang=ts"
export * from "./Journey.vue?vue&type=script&lang=ts"

import "./Journey.vue?vue&type=style&index=0&id=2160a90e&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2160a90e"]])

export default __exports__